import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HttpClient, provideHttpClient, withFetch } from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpLoaderFactory } from "./app.component";
import { UtilsProvider } from "./common/providers/utils-provider.service";
import { AppDatePipe } from "./common/pipes/app-date";
import { DatePipe } from "@angular/common";
import { ConfigProvider } from "./config-provider.service";
import { MatDatepicker } from "@angular/material/datepicker";
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS, provideNativeDateAdapter, DateAdapter } from "@angular/material/core";
import { DurationVerbosePipe } from "./common/pipes/duration-verbose";
import { FilterExerciceRowPipe } from "./exercices/pipes/filter-exercice-row";
import { DocumentService } from "./document/providers/document.service";
import { CommunicationsProvider } from "./communications/providers/communications-provider";
import { GroupedMeasureValuesPipe } from "./test/pipes/grouped-measure-values-pipe";
import { ScrollTrackerDirective } from "./directive/ScrollTrackerDirective";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter, provideMomentDateAdapter } from "@angular/material-moment-adapter";
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/it';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    dateFormat: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export function initializeMomentLocale() {
  return () => {
    moment.updateLocale('fr', {
      week: {
        dow: 1, // Monday as the first day of the week
      }
    });
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: APP_INITIALIZER, useFactory: initializeMomentLocale, multi: true},
    {provide: MAT_DATE_LOCALE, useValue: 'fr-CH'},
    {provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS},
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    provideMomentDateAdapter( MY_DATE_FORMATS ),
    // provideNativeDateAdapter( MY_DATE_FORMATS ),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    provideRouter(routes),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(withFetch()),
    AppDatePipe,
    DatePipe,
    DurationVerbosePipe,
    GroupedMeasureValuesPipe,
    FilterExerciceRowPipe,
    MatDatepicker,
    UtilsProvider,
    ConfigProvider,
    CommunicationsProvider,
    DocumentService,
    ScrollTrackerDirective,
  ],
};
